import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Permission } from '../permissions';

/**
 * Route guard that checks the current user holds the permission declared on
 * the route's `data.requiredPermission` — a single {@link Permission}, or an
 * array meaning "any one of these" (used where one screen serves more than
 * one backend-permission domain, e.g. /permissions/manage's roles tab vs
 * employees tab). Routes with no `requiredPermission` pass through unchecked
 * — used for parent routes that group screens with different (or no)
 * backend-confirmed permission yet; see PROJECT-MAP.md for which screens
 * still have no backend-side permission to gate on.
 */
export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const auth   = inject(AuthService);
    const router = inject(Router);

    const required = route.data['requiredPermission'] as Permission | Permission[] | undefined;
    if (!required) return true;

    const requiredList = Array.isArray(required) ? required : [required];
    if (requiredList.some(permission => auth.hasPermission(permission))) return true;

    return router.createUrlTree(['/unauthorized']);
};
